var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandlebaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    id: "handlebars",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.59,62.67a7.14,7.14,0,0,0,2.31-3.48c.46-2,.36-3.94-2.31-5.3C7.82,50.47,3.45,56.57,2.77,58s-1.74,3.68-1,8.84,3.19,9.9,11,11.73A32.89,32.89,0,0,0,34.77,76c6.84-3.26,19.7-9,22.94-9.58a28.15,28.15,0,0,1,6.49-.81V57.76a18,18,0,0,0-17.38-9.15C34.43,49.59,29.51,56,26.49,58.7s-8.61,9.17-12.37,8S9.31,61,10.64,59.56s2.37-1.18,3.18,0A6.24,6.24,0,0,1,14.59,62.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.41,62.67a7.14,7.14,0,0,1-2.31-3.48c-.46-2-.36-3.94,2.31-5.3,6.76-3.43,11.13,2.67,11.81,4.11s1.74,3.68,1,8.84-3.19,9.9-11,11.73A32.89,32.89,0,0,1,93.23,76c-6.84-3.26-19.7-9-22.94-9.58a28.15,28.15,0,0,0-6.49-.81V57.76a18,18,0,0,1,17.38-9.15c12.39,1,17.32,7.38,20.34,10.08s8.61,9.17,12.37,8,4.81-5.76,3.48-7.19-2.37-1.18-3.18,0A6.24,6.24,0,0,0,113.41,62.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandlebaricon);
export default __webpack_public_path__ + "static/media/handlebaricon.a75991ec8e816963a6e8ee589ed7681b.svg";
export { ForwardRef as ReactComponent };